import React from 'react';

import { useStoreRequired } from 'features/store/hooks/use-store-required';

import { useAcceleratorBadgesOnMenuExperiment } from 'experiments/use-accelerator-badges-on-menu-experiment';
import { useEnableUnifiedMenu } from 'hooks/use-enable-unified-menu';
import { MenuTabsWrap } from 'pages/menu/components/menu-tabs';
import { MainMenuPage } from 'pages/menu/main-menu-page';
import { MainMenuPageV2 } from 'pages/menu/main-menu-page-v2';
import { MainMenuPage as MainMenuBadgesExperiment } from 'pages/menu/main-menu-page/main-menu-badges-experiment';

export default function MenuScreen() {
  useStoreRequired();

  return <MenuInner />;
}

const MenuInner = React.memo(() => {
  const enableUnifiedMenu = useEnableUnifiedMenu();
  const enableMenuAcceratorBadgesExperiment = useAcceleratorBadgesOnMenuExperiment();
  return (
    <MenuTabsWrap>
      {enableUnifiedMenu ? (
        <MainMenuPageV2 />
      ) : enableMenuAcceratorBadgesExperiment ? (
        <MainMenuBadgesExperiment />
      ) : (
        <MainMenuPage />
      )}
    </MenuTabsWrap>
  );
});
